/*! SpringRoll PBSKIDS 1.0.0 */
/**
 * @module Google Analytics
 * @namespace springroll
 * @requires Core
 */
(function(undefined)
{
	// Include classes
	var ApplicationPlugin = include('springroll.ApplicationPlugin');

	/**
	 * @class Application
	 */
	var plugin = new ApplicationPlugin(10);

	plugin.setup = function()
	{

		/**
		 * Track a Google Analytics eventanalyticEvent
		 * @method analyticEvent
		 * @param {String} action The action label
		 * @param {String} [label] The optional label for the event
		 * @param {Number} [value] The optional value for the event
		 */
		this.analyticEvent = function(action, label, value)
		{
			var data = {
				category: this.name,
				action: action,
				label: label,
				value: value
			};

			if (this.container)
			{
				this.container.send('analyticEvent', data);
			}
			/**
			 * An event was sent for Google Analtyics
			 * @event analyticEvent
			 * @param {Object} data
			 * @param {String} data.category The event category
			 * @param {String} data.action The event action
			 * @param {String} [data.label] Optional label
			 * @param {Number} [data.value] Optional value
			 */
			this.trigger('analyticEvent', data);
		};
	};

	plugin.teardown = function()
	{
		this.analyticEvent = null;
	};

}());
/**
 * @module GoogleAnalyticEventsTab module
 * @namespace GoogleAnalyticEventsTab
 * @requires Core
 */
(function($)
{

	//Import classes
	var Debug = include("springroll.Debug", false);

	/**
	 * This class is responsible for creating google analytics event tab and display event.
	 * @class GoogleAnalyticEventsTab
	 * @constructor
	 */
	var GoogleAnalyticEventsTab = function(app)
	{
		if (app.loggingPanel)
		{
			this._googleAnalyticEventsTab = app.loggingPanel.createTab(
				"analytics-log",
				"Google Analytics"
			);
			this.createTable(this._googleAnalyticEventsTab);
			app.on(
				"analyticEvent",
				function(eventData)
				{
					this.displayGoogleAnalyticEvent(eventData);
				}.bind(this)
			);
		}
	};

	var p = extend(GoogleAnalyticEventsTab);
	/**
	 * Create table view for logs
	 * @param {Jquery Object}  $div
	 */
	p.createTable = function($div)
	{
		var $table = $("<table></table>"),
			$thead = $("<thead></thead>"),
			$tbody = $("<tbody></tbody>"),
			$tr;
		$tr = $("<tr></tr>");
		$("<th></th>").text("Category").appendTo($tr);
		$("<th></th>").text("Action").appendTo($tr);
		$("<th></th>").text("Label").appendTo($tr);
		$("<th></th>").text("Value").appendTo($tr);
		$tr.appendTo($thead);
		$thead.appendTo($table);

		$tr = $("<tr></tr>").addClass("no-logs");
		$("<td></td>").attr("colspan", "4").css("text-align", "center").text("No Logs").appendTo($tr);
		$tr.appendTo($tbody);
		$tbody.appendTo($table);
		this.$tbody = $tbody;
		$table.appendTo($div);
	};
	/**
	 * Display google analytic event
	 * @method displayGoogleAnalyticEvent
	 */
	p.displayGoogleAnalyticEvent = function(log)
	{
		try
		{
			var $tr = $("<tr></tr>");
			$("<td></td>").text(log.category).appendTo($tr);
			$("<td></td>").text(log.action && log.action || "No Action").appendTo($tr);
			$("<td></td>").text(log.label && log.label || "No label").appendTo($tr);
			$("<td></td>").text(log.value && log.value || "No value").appendTo($tr);
			this.$tbody.find("tr.no-logs").remove();
			this.$tbody.prepend($tr);
		}
		catch (e)
		{
			if (Debug)
			{
				Debug.error(e);
			}
		}
	};

	/**
	 * Destroy this google analytics tab, don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		if (this._googleAnalyticsTab)
		{
			this._googleAnalyticsTab.remove();
		}
	};

	//Assign to namespace
	namespace(
		"springroll.pbskids"
	).GoogleAnalyticEventsTab = GoogleAnalyticEventsTab;
})(window.$);